import React from 'react';

export const MinusCircleDecorated = () => (
  <g transform="matrix(22.088127,0,0,22.088127,-12303.087,-13230.788)">
    <g
      transform="matrix(0.79828648,0,0,0.79828648,561.88952,603.8895)"
      fill="none"
      stroke="#748498"
      strokeWidth="1.5"
    >
      <circle cx="24.5" cy="24.5" r="24.5" stroke="none" />
      <circle cx="24.5" cy="24.5" r="23.75" fill="none" />
    </g>
    <g
      transform="matrix(0.79828648,0,0,0.79828648,565.08266,607.08265)"
      fill="none"
      stroke="#748498"
      strokeLinecap="round"
      strokeWidth="1.5"
      strokeDasharray="0, 5"
    >
      <circle cx="20.5" cy="20.5" r="20.5" stroke="none" />
      <circle cx="20.5" cy="20.5" r="19.75" fill="none" />
    </g>
    <g
      transform="matrix(0.79828648,0,0,0.79828648,571.46895,620.25437)"
      fill="#ffffff"
      stroke="#748498"
      strokeWidth="1.5"
    >
      <rect width="25" height="8" rx="4" stroke="none" x="0" y="0" />
      <rect x="0.75" y="0.75" width="23.5" height="6.5" rx="3.25" fill="none" />
    </g>
  </g>
);
